import { useState } from "react";
import { useAction } from "wasp/client/operations";
import { upsertWalletInitialBalance } from "wasp/client/operations";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../client/components/ui/dialog";
import { Button } from "../client/components/ui/button";
import { Input } from "../client/components/ui/input";
import { Label } from "../client/components/ui/label";
import useTranslation from "../client/hooks/useTranslation";
import { format } from "date-fns";

interface WalletInitialBalanceModalProps {
  open: boolean;
  onClose: () => void;
  propFirmTemplateId: string;
  currentInitialBalance?: number;
  currentInitialBalanceDate?: string | Date | null;
  onMutated: () => void;
}

export function WalletInitialBalanceModal({
  open,
  onClose,
  propFirmTemplateId,
  currentInitialBalance = 0,
  currentInitialBalanceDate,
  onMutated,
}: WalletInitialBalanceModalProps) {
  const t = useTranslation();
  const w = t.propFirmManager.wallet;
  const upsert = useAction(upsertWalletInitialBalance);
  const [amount, setAmount] = useState(String(currentInitialBalance));
  const [date, setDate] = useState(
    currentInitialBalanceDate
      ? format(new Date(currentInitialBalanceDate as string), "yyyy-MM-dd")
      : format(new Date(), "yyyy-MM-dd")
  );
  const [loading, setLoading] = useState(false);

  const handleSave = async () => {
    setLoading(true);
    try {
      await upsert({
        propFirmTemplateId,
        initialBalance: parseFloat(amount) || 0,
        initialBalanceDate: date || undefined,
      });
      onMutated();
      onClose();
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="sm:max-w-sm">
        <DialogHeader>
          <DialogTitle>{w.setInitialBalance}</DialogTitle>
        </DialogHeader>
        <div className="space-y-3 pt-1">
          <div>
            <Label>{w.initialBalanceLabel}</Label>
            <Input
              type="number"
              min="0"
              step="0.01"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
              placeholder="0"
            />
          </div>
          <div>
            <Label>{w.initialBalanceDateLabel}</Label>
            <Input
              type="date"
              value={date}
              onChange={(e) => setDate(e.target.value)}
            />
          </div>
          <Button className="w-full" onClick={handleSave} disabled={loading}>
            {w.saveInitialBalance}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
